<template>
	<v-card class="delete-dialog">
		<v-card-title class="headline pb-3 text-center">
			Change Polling Interval
		</v-card-title>
		<v-card-text>
			<v-text-field
				v-model="intervalDialog.value"
				type="number"
				hide-details
				class="edit-interval"
				:min="0"
				:max="999"
				suffix="Seconds"
				label="Polling Interval"
				oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null;
								 if(this.value.length > 3) this.value = this.value.slice(0, -1);"
			></v-text-field>
			<v-spacer></v-spacer>
		</v-card-text>
		<v-card-actions class="px-5">
			<v-btn class="cancel-btn" text @click="$emit('close')">Cancel</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="save-btn" depressed @click="editInterval">Save</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
export default {
  props: ['intervalDialog'],
  methods: {
    editInterval () {
      this.$emit('editInterval', this.intervalDialog)
    }
  }
}
</script>
